import { Grid, makeStyles, Modal as MuiModal, Typography } from "@material-ui/core";

import { Icon } from "./Icon";
import RemoveIcon from "../../assets/images/icons/remove.svg";

const useStyle = makeStyles(() => ({
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export const Modal = ({ open, onClose, children }) => {
  const classes = useStyle();

  return (
    <MuiModal className={classes.modal} open={open} onClose={onClose}>
      <div>{children}</div>
    </MuiModal>
  );
};

export const ModalTitle = ({ title, onClose }) => {
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Typography variant="h2">{title}</Typography>
      <Icon src={RemoveIcon} hoverable onClick={onClose} />
    </Grid>
  );
};
